import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import useAxios from '../hook/useAxios';
import useRouter from '../hook/useRouter';
import { IPriceItem, IStock } from '../interface/IPrice';
import { RootState, store } from '../store';
import { PriceItemStockItem } from './PriceItemStockItem';

export const PriceItemStock = ({
    it,
    isopen,
    qtitySet,
}: {
    it: IPriceItem;
    isopen: boolean;
    qtitySet: React.Dispatch<React.SetStateAction<number>>;
}) => {
    const l10n = useSelector((state: RootState) => state.main.l10n);
    const { res, loading, error, fetchData } = useAxios<IStock>();
    const config = store.getState().main.config;
    const [pagenum, pagenumSet] = useState<number>(1);
    const isFirst = useRef(true);
    const [stockList, stockListSet] = useState<IStock['contents']>([]);
    const [pagination, paginationSet] = useState<IStock['pagination']>({ page: 0, size: 0, lastPage: 0, total: 0, limit: 10000 });

    const { getValue } = useRouter(['bless']);

    useEffect(() => {
        if (isopen && isFirst.current) {
            isFirst.current = false;
            callApi(1);
        }
    }, [isopen]);

    const callApi = (_pagenum: number) => {
        fetchData({
            config: store.getState().main.config,
            method: 'get',
            l10n: l10n,
            path: `/${config.service}/v2.0/price/search/item/${it.itemId}/stock`,
            param: {
                serverId: it.serverId,
                enchantLevel: it.enchantLevel,
                blessedType: getValue('bless') || 0,
                page: _pagenum,
                size: 5,
            },
        });
    };

    useEffect(() => {
        if (error) {
            toast.dismiss();
            toast(
                (t) => (
                    <div className="toast-wrapper">
                        <span className="toast-title" dangerouslySetInnerHTML={{ __html: error.msg }}></span>
                    </div>
                ),
                {
                    duration: 3000,
                    className: 'gameinfo-toast',
                    position: 'bottom-center',
                }
            );
        }
    }, [error]);

    useEffect(() => {
        if (res && res.contents) {
            stockListSet([...stockList, ...res.contents]);

            paginationSet(res.pagination);
            qtitySet(res.pagination.total);
        }
    }, [res]);

    const onMore = () => {
        pagenumSet((current) => {
            if (current < pagination.lastPage) {
                callApi(pagenum + 1);
                return pagenum + 1;
            }
            return current;
        });
    };

    if (it.quantity < 1) {
        return null;
    }

    if (stockList && stockList.length < 1) {
        return null;
    }

    return (
        <section className="tradeableitems">
            <header>
                <span
                    className="qty"
                    dangerouslySetInnerHTML={{
                        __html: l10n['common.itemlistper'].replace('{N}', `${pagination.total > 99 ? '99+' : pagination.total}`),
                    }}
                ></span>
            </header>
            <article>
                <ul>
                    {stockList.map((item, idx) => (
                        <PriceItemStockItem key={item.itemId + idx} it={item} />
                    ))}
                </ul>
            </article>
            {pagination.lastPage > pagination.page ? (
                <footer>
                    <button className="btn-more" onClick={onMore}>
                        {l10n['common.viewmore']}
                        <i className="ico-arrow"></i>
                    </button>
                </footer>
            ) : null}
        </section>
    );
};
